<template>
  <section class="p-2">
    <div>
      <v-form>
        <v-card>
          <v-card-title class="d-flex justify-space-between p-0 m-0">
            <div class="ps-2 headingFontsize"><v-icon small>mdi-content-save-plus-outline</v-icon>Add Payee Route</div>
            <div>
              <bread-crumb :bread-crumbs="['Payee Route', 'Add Payee Route']" />
            </div>
          </v-card-title>
          <v-divider class="p-0 m-0 primary--text"></v-divider>


          <!-- <v-toolbar flat dense >
            <v-toolbar-title ></v-toolbar-title>
          </v-toolbar> -->
          <!-- <div style="border:solid 1px;color:grey" class="ms-4 me-4"></div> -->
          <!-- <v-divider   style="border: solid 1px;color: green;  "></v-divider> -->
          <v-card-text>
            <v-row class="mt-2 ms-1 me-1 mt-1">
              <v-col cols="12" md="4">
                <label class="labelFontsize  mb-0">Payout Country</label>
                <v-autocomplete outlined dense class="rounded" placeholder="Payout Country"> </v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="labelFontsize  mb-0">Partner</label>
                <v-autocomplete outlined dense class="rounded" placeholder="Partner"> </v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="labelFontsize  mb-0">Branch</label>
                <v-autocomplete outlined dense class="rounded" placeholder="Branch"> </v-autocomplete>
              </v-col>

            </v-row>

            <v-row class="ms-1 me-1">
              <v-col cols="12" md="4">
                <label class="labelFontsize  mb-0">Cash Pickup</label>
                <v-autocomplete outlined dense class="rounded" placeholder="Cash Pickup"> </v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="labelFontsize  mb-0">Bank Transfer</label>
                <v-autocomplete outlined dense class="rounded" placeholder="Bank Transfer"> </v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="labelFontsize  mb-0">Currency</label>
                <v-autocomplete outlined dense class="rounded" placeholder="Currency"> </v-autocomplete>
              </v-col>

            </v-row>
            <div class="row">
              <div class="col-md-12" style="display:flex; justify-content:end; ">
                <v-btn depressed  class="text-capitalize me-3  mb-10" small color="primary"><v-icon small>mdi-content-save-plus-outline</v-icon>Add</v-btn>
                <v-btn depressed  class="text-capitalize  me-5 mb-10" small color="primary" outlined>Cancel</v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>

      </v-form>
    </div>

  </section>
</template>
<script>

import BreadCrumb from "@/components/navigations/BreadCrumb.vue"
export default {
  name:"Add Payee Route",
  data() {
    return {
      dialog: false,
    }
  },
  components: {
    BreadCrumb,
    // Loading
  },
}
</script>
<style scoped  lang="scss">
@import "@/global.scss";
</style>